(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-page-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const boostHeaderSelectors =
      '.boost-sd__header-title, .boost-sd__breadcrumb, .boost-sd__breadcrumb-container, .boost-sd__header-description';
    const descriptionId = 'collection-description-container';
    const templateId = 'collection-description-template';

    const removeBoostHeader = () => {
      document.querySelectorAll(boostHeaderSelectors).forEach((element) => element.remove());
    };

    const restoreDescriptionForBoost = () => {
      if (document.getElementById(descriptionId)) return;

      const template = document.getElementById(templateId);
      const headerInner = document.querySelector(
        '.collection-page-header .container, .collection-page-header .container-fluid'
      );
      if (!template || !headerInner) return;

      const description = document.createElement('div');
      description.id = descriptionId;
      description.style.display = 'none';
      description.appendChild(template.content.cloneNode(true));
      headerInner.appendChild(description);
    };

    const sync = () => {
      removeBoostHeader();
      restoreDescriptionForBoost();
    };

    let scheduled = false;
    const scheduleSync = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        sync();
      });
    };

    sync();

    const root = document.querySelector('#MainContent') || document.body;
    const observer = new MutationObserver(scheduleSync);
    observer.observe(root, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
